export function parseExplicitOverlayNumber(value) {
  if (value == null || typeof value === "boolean") return null;

  if (typeof value === "string" && value.trim() === "") {
    return null;
  }

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
}

export function buildOrderOverlayGroupKey(price) {
  const parsedPrice = parseExplicitOverlayNumber(price);
  return parsedPrice == null ? "" : parsedPrice.toFixed(2);
}

export function getPremiumModeTpOverlayPrice(basePremium, takeProfit, takeProfitMode) {
  if (takeProfitMode !== "Premium") return null;

  const parsedBasePremium = parseExplicitOverlayNumber(basePremium);
  const parsedTakeProfit = parseExplicitOverlayNumber(takeProfit);

  if (parsedBasePremium == null || parsedTakeProfit == null) {
    return null;
  }

  return parsedBasePremium - parsedTakeProfit;
}

const MOBILE_ORDER_OVERLAY_TYPE_PRIORITY = {
  active: 0,
  pending: 1,
  tp: 2,
  sl: 3,
};

export function getMobileOrderOverlayLabelKeys(groups, currentPrice, maxLabels = 5) {
  if (!Array.isArray(groups) || maxLabels <= 0) return [];

  const parsedCurrentPrice = parseExplicitOverlayNumber(currentPrice);

  return groups
    .map((group, index) => {
      const parsedPrice = parseExplicitOverlayNumber(group?.price);
      if (parsedPrice == null) return null;

      return {
        key: buildOrderOverlayGroupKey(parsedPrice),
        price: parsedPrice,
        priority:
          MOBILE_ORDER_OVERLAY_TYPE_PRIORITY[group?.primaryType] ?? Number.POSITIVE_INFINITY,
        distance:
          parsedCurrentPrice == null
            ? Number.POSITIVE_INFINITY
            : Math.abs(parsedPrice - parsedCurrentPrice),
        index,
      };
    })
    .filter(Boolean)
    .sort((a, b) => {
      const priorityDiff = a.priority - b.priority;
      if (priorityDiff !== 0) return priorityDiff;

      const distanceDiff = a.distance - b.distance;
      if (distanceDiff !== 0) return distanceDiff;

      const priceDiff = b.price - a.price;
      if (priceDiff !== 0) return priceDiff;

      return a.index - b.index;
    })
    .slice(0, maxLabels)
    .map((entry) => entry.key);
}
